// extracted by css-extract-rspack-plugin
export default {"backdropContainer":"eC2gk_nuEgwSkpzh","backdrop":"lztCny6ftcv3NEnL","spinner":"oZ0QY1LHegkCChVC"};